module.exports = __webpack_public_path__ + "static/media/battery_20.ad72dea0.svg";